import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/ClientsModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { MySelect, Text, TextArea, TextFloat, TextNumber } from '../../inputs/inputs';
import { getCountries, getStates, getCurrencies } from '../../../models/MasterModel';
import { formatDataBeforeDisplay, formatDataBeforeSend, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';

export const ClientForm = ({module, showModal, setShowModal, refreshData, data, modalKey}) => {

  const inputFields = {
    client_name: '',
    client_domain: '',
    client_msa_status: '',
    client_size: '',
    client_revenue: '',
    client_presence: '',
    client_is_msp: '0',
    client_msp_name: '',
    client_is_vms_tool_used: '0',
    client_link: '',
    client_login_username: '',
    client_login_password: '',
    client_website: '',
    client_country: '',
    client_billing_state: '',
    client_address: '',
    client_remarks: '',
    client_currency: '',
    client_gstin: '',
    client_pincode: '',
  }
  const formatOptions = [];

  const yesNoOptions = [
    { value: 1, label: 'Yes'},
    { value: 0, label: 'No'},
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate(); 

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const [currencies, setCurrencies] = useState([]);
  const fetchCurrencies = async () => {
    try {
      const result = await getCurrencies();

      const currenciesOptions = result.currencies.map(currency => ({
        label: currency.currency_name,
        value: currency._currency_id
      }));

      setNotificationCount(localStorage.getItem('unread_notification_count'));

      setCurrencies(currenciesOptions);
    } catch (error) {
      //console.error(error);
    }
  };
  const [countries, setCountries] = useState([]);
  const fetchCountries = async () => {
    try {
      const result = await getCountries();

      const countriesOptions = result.countries.map(country => ({
        label: country.country_name,
        value: country._country_id
      }));

      setNotificationCount(localStorage.getItem('unread_notification_count'));

      setCountries(countriesOptions);
    } catch (error) {
      //console.error(error);
    }
  };
  useEffect(() => {
    fetchCountries();
    fetchCurrencies();
  }, []);

  const [states, setStates] = useState([]);
  const fetchStates = async (_country_id = null) => {
    try {
      const result = await getStates({user_token: user_data.user_token, page: 1, limit: -1, _country_id : _country_id});

      const options = result.states.map(row => ({
        value: row._state_id,
        label: row.state_name
      }));

      setStates(options);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   fetchStates();
  // }, []);
  const countryChange = async(value) => {
    //refreshData();
    console.log(value);
    fetchStates(value);
  }

  const closeModal = () =>{
    setId('');
    setFields(inputFields);
    setErrors({});

    setShowModal(false);
  }

  useEffect(() => {
    // This effect will be called whenever data changes
    if (data) {
      setId(data[module.primaryCol]);
      setFields(formatDataBeforeDisplay(data, formatOptions));
      setErrors({});
    }
  }, [data, modalKey]);

  const validator = useRef(new SimpleReactValidator(validorSettings()));
  const submit = async(e) => {
    e.preventDefault();

    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      let response;
      if (data) {
        response = await model.update(user_data.user_token, id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        closeModal();

        model.saveToStorage(response.data[module.key], response.data.pagination);
        refreshData();
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  }

  return (
    <Modal className="cms-modal-form" show={showModal} onHide={closeModal} size='xl' backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>{modalKey == null ? 'Add' : 'Edit'} {module.singularTitle}</Modal.Title>
        </Modal.Header>

        <form onSubmit={submit}>
          <Modal.Body>
          <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <Text column="client_name" label="Client Name" required={true} fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <Text column="client_domain" label="Domain / LOB" fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <Text column="client_msa_status" label="MSA Status" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <TextNumber column="client_size" label="Size" fields={fields} setFields={setFields} errors={errors} />
              </div>

              <div className="col-xl-4">
                <TextFloat column="client_revenue" label="Revenue" fields={fields} setFields={setFields} errors={errors} />
              </div>

              <div className="col-xl-4">
                <Text column="client_presence" label="Presence" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <MySelect options={yesNoOptions} firstOption={false} column="client_is_msp" label="Is MSP?" fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4" style={{display: (fields.client_is_msp == 1 ? 'block' : 'none')}}>
                <div>
                  <Text column="client_msp_name" label="MSP Name" fields={fields} setFields={setFields} errors={errors} />
                </div>
              </div>
              
              <div className="col-xl-4">
                <MySelect options={yesNoOptions} firstOption={false} column="client_is_vms_tool_used" label="VMS Tool Used" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>

            <div className="row gy-2 mb-3" style={{display: (fields.client_is_vms_tool_used == 1 ? 'flex' : 'none')}}>
              <div className="col-xl-4">
                <Text column="client_link" label="VMS Link" fields={fields} setFields={setFields} errors={errors} validator={validator} rules='url' />
              </div>
              
              <div className="col-xl-4">
                <Text column="client_login_username" label="VMS Username" fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <Text column="client_login_password" label="VMS Password" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              
              <div className="col-xl-4">
                <MySelect options={countries} onChange={countryChange}
                 column="client_country" label="Client Country" fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-xl-4">
                <MySelect options={states} column="client_billing_state" label="Billing State" fields={fields} setFields={setFields} errors={errors} />
              </div>

              <div className="col-xl-4">
                <Text column="client_pincode" label="Pincode" fields={fields} setFields={setFields} errors={errors} validator={validator} />
              </div>
            </div>
            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <Text column="client_website" label="Website" fields={fields} setFields={setFields} errors={errors} validator={validator} rules='url' />
              </div>
              <div className="col-xl-4">
                <MySelect options={currencies} column="client_currency" label="Currency" fields={fields} setFields={setFields} errors={errors} />
              </div>
              <div className="col-xl-4">
                <Text column="client_gstin" label="Client GST" fields={fields} setFields={setFields} errors={errors} validator={validator} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-6">
                <TextArea column="client_address" label="Address" fields={fields} setFields={setFields} errors={errors} />
              </div>

              <div className="col-xl-6">
                <TextArea column="client_remarks" label="Remarks" fields={fields} setFields={setFields} errors={errors} />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
              <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
              <button className="btn btn-primary" disabled={loading}>
                {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Submit'}
              </button>
          </Modal.Footer>
        </form>
    </Modal>
  );
};
